import { render, staticRenderFns } from "./IndexLayout.vue?vue&type=template&id=0b572deb&scoped=true&"
import script from "./IndexLayout.vue?vue&type=script&lang=js&"
export * from "./IndexLayout.vue?vue&type=script&lang=js&"
import style0 from "./IndexLayout.vue?vue&type=style&index=0&id=0b572deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b572deb",
  null
  
)

export default component.exports